import { Component, effect, OnInit } from "@angular/core";
import { Subject, Subscription } from "rxjs";
import { Router, NavigationEnd } from "@angular/router";


import { ItemFormat } from "../../../shared/models/itemFormat.model";
import { DirectSessionLogicService } from "../../../shared/direct-session-logic.service";
import { PromoService } from "../../../shared/promo.service";
import { ConfigData } from "../../../shared/models/config-data.model";
import { ItemsService } from "../../../shared/items.service";
import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";
import { CouponFormat } from "../../../shared/models/couponFormat.model";
import { environment } from "../../../../environments/environment";


@Component({
    selector: 'app-form-item-single-select',
    template:`
        <!-- <h2>Available plan options:</h2> -->

        @for(selectOptions of allItems; track selectOptions.itemFeatureRef){

            @if(selectOptions.tagLine){
                <h3 class="option-tagline">
                    <!-- Apply the method to split the TagLine and bind the parts -->
                    {{splitTagLine(selectOptions).before}}
                    <strong>{{splitTagLine(selectOptions).bold}}</strong>
                    {{splitTagLine(selectOptions).after}}
                </h3>
            }
            <h5 class="option-description">{{selectOptions.description}}</h5>
            <ul>
                @for (points of selectOptions.salesPoints; track points) {
                    <div class="feature-line">
                        <img src="assets/Icons/check.svg" alt="checkmark" class="icon-check">
                        <div>{{points}}</div>
                    </div>
                }
            </ul>
            <div class="outer-item-wrapper">
                <div class="item p-3">
                    <img src="{{selectOptions.imageUrl}}" 
                        alt="{{selectOptions.displayName}}"
                        class="item-icon-box"
                    >
                    <div class="item-description">
                        <div class="item-description-title">{{selectOptions.displayName}}</div>
                        @if(!selectOptions.priceAsWholeNumber){
                            <div class="item-description-price">$ {{selectOptions.price}} / month</div>

                        }
                        <!-- <div *ngIf="">
                        </div> -->
                        @if(selectOptions.priceAsWholeNumber){
                            <div class="item-description-price">$ {{selectOptions.price}}.00 / month</div>
                        }
                    </div>
    
                    @if(!selectOptions.addedToCart && !isMobile){
                        <button class="item-add-button btn btn-sm" type="button" (click)="singleSelectItem(selectOptions)">Add Now</button>
                    }
                    @if(selectOptions.addedToCart && !isMobile){
                        <label class="item-add-button-transparent p-2">Option Selected</label>
                    }
    
                </div>
    
                @if(isMobile){
                    <div class="flex row" style="margin-left: 0px; margin-right: 0px;">
                        @if(!selectOptions.addedToCart){
                            <button class="mobile-container-add-button btn btn-sm" type="button" (click)="singleSelectItem(selectOptions)">Add Now</button>
                        }
                        @if(selectOptions.addedToCart){
                            <label class="mobile-container-add-button-transparent p-2">Option Selected</label>
                        }
                    </div>
                }
            </div>
    
            @if(allItems.length > 1){
                <div class="inter-item-spacer"></div>
            }
        }
    `,
    styleUrls: ['./form-item-single-select.component.scss'],
    standalone: true,
    imports: []

})
export class FormItemSingleSelectComponent implements OnInit{

    configData: ConfigData = {} as ConfigData;
    allItems: ItemFormat[] = [];

    get coupon(): CouponFormat {
        return this.promoService.couponSignal();
    }
    get optionItems(): ItemFormat[] {
        return this.itemService.itemsViewSignalValue;
    }

    get selectedItems(): ItemFormat[] {
        return this.directSessionLogic.cartItemsSignal();
    }


    onNavEndValue: string = "";
    
    private routerSubscription : Subscription

    private unsubscriber = new Subject<void>();
    describedFeatures: string[] = [];

    isMobile: boolean = false;

    isProd: boolean = true; //need to fix this and the related logic on page or remove it

    constructor(
        public directSessionLogic: DirectSessionLogicService,
        public itemService: ItemsService,
        public promoService: PromoService,
        private router: Router,
        private responsive: BreakpointObserver
    ){
        this.configData = environment as ConfigData;

        
        this.routerSubscription = this.router.events.subscribe(event =>{
            if(event instanceof NavigationEnd){
                this.escapeCheck();
                this.getItemsOnNavEnd( event.urlAfterRedirects );
            }
        })
        
        // Create an Observable that emits a value when the session.selections array changes
        effect(() => {
            this.updatePricingFromCoupon();
            this.updateDisplayedItems();
            this.directSessionLogic.verifyCurrentStepLockout();
        });

    }

    ngOnInit() {   
        this.escapeCheck();
     
        this.responsive.observe([
            Breakpoints.XSmall , Breakpoints.Small
              ])
              .subscribe(result => {
                this.isMobile = false; 
                if (result.matches) 
                  this.isMobile = true;      
          }
        );
    }
    ngOnDestroy(): void {
        this.unsubscriber.next();
        this.unsubscriber.complete();

        if (this.routerSubscription) {
            this.routerSubscription.unsubscribe();
        }
    }
    escapeCheck(){
        if(this.directSessionLogic.planSelectedSignal().name === undefined || this.directSessionLogic.planSelectedSignal().name === null) {
            console.log("no plan selected, escaping to top level");
            this.directSessionLogic.escapeToTopLevelSignal();
        }
    } 
    splitTagLine(selectOptions: ItemFormat): { before: string, bold: string, after: string } {
        //will eventually need to format this to handle multiple bold parts -AG
        const boldPart = selectOptions.boldTagLineText[0];
        const startIndex = selectOptions.tagLine.indexOf(boldPart);
        if (startIndex !== -1) {
          return {
            before: selectOptions.tagLine.substring(0, startIndex),
            bold: boldPart,
            after: selectOptions.tagLine.substring(startIndex + boldPart.length)
          };
        }
        // Return the original tagLine if the bold part isn't found
        return { before: selectOptions.tagLine, bold: '', after: '' };
    }


    singleSelectItem(selectOptions: ItemFormat){
        let sessionItemsSelected = this.directSessionLogic.cartItemsSignalValue;
        
        if(sessionItemsSelected != undefined && sessionItemsSelected.length > 0){
            let alternateSelections = sessionItemsSelected.filter(item =>
                item.itemPageRef === selectOptions.itemPageRef
            );

            if(alternateSelections.length > 0) this.toggleItem(alternateSelections[0]);
        }
        this.toggleItem(selectOptions);


        /// if this step requires you to select an item, mark it complete once an item is selected
        let currentStep = this.directSessionLogic.getCurrentStepSignal();
        if(currentStep.requiredChoice) {
            this.directSessionLogic.completeCurrentPage();
        }
    }

    toggleItem(selectOptions: ItemFormat){
        let items = this.directSessionLogic.cartItemsSignalValue;

        if(items === undefined){ items = []; }
        if(!this.isProd) console.log("item: ", items);
        if(items.includes(selectOptions)){
            this.directSessionLogic.removeItemFromCartItemsSignal(selectOptions);
        } else {
            selectOptions.addedToCart = true;
            
            const indexToUpdate = this.allItems.findIndex(item => 
                item.itemFeatureRef === selectOptions.itemFeatureRef
            ); 
            if (indexToUpdate !== -1) {
                // Replace the item at the found index with the updated selectOptions
                this.allItems[indexToUpdate] = selectOptions;
            }

            this.directSessionLogic.addItemToCartItemsSignal(selectOptions);
        }
    }

    updateDisplayedItems(){
        if(this.selectedItems != undefined ){

            let itemsRefArray = this.selectedItems.map(item => item.itemFeatureRef);

            this.allItems.forEach(item => {
                if(itemsRefArray.includes(item.itemFeatureRef)){
                    item.addedToCart = true;
                }else{
                    item.addedToCart = false;
                }
            });
        }
    }

    async getItemsOnNavEnd(url: string){
        this.onNavEndValue = url.split("/").pop() ?? "";

        this.allItems = this.itemService.ItemViewForNav(this.onNavEndValue);
        this.updatePricingFromCoupon();
    }

    updatePricingFromCoupon(){
        //for each update for any items from allItems that have a discount from the coupon 
        //applied in the session

        //reset items to original price
        this.allItems = this.allItems.map(item => {
            item.price = item.originalPrice;
            return item;
        });


        let itemDiscounts = this.promoService.couponSignalValue?.subCouponItems;
        if(itemDiscounts?.length){
            this.allItems = this.allItems.map(item => {
                const itemDiscount = itemDiscounts.find( discountedItem => 
                    discountedItem.itemRef === item.itemFeatureRef
                );
                if( itemDiscount !== undefined){
                    item.price -= itemDiscount.dollarDiscount;
                    item.price -= item.price * (itemDiscount.percentDiscount / 100);
                }
                return item;
            });            
        }
    }

}

 